import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {AddContentStore} from '../../../x7/content-parts/AddContentStore';
import {SelectQuestionEditStore} from './SelectQuestionEditStore';
import {selectQuestionEditStoreRenderer} from './selectQuestionEditStoreRenderer';

@observer
export class SelectQuestionCreateComponent extends React.Component<{ store: AddContentStore }> {
  readonly store: SelectQuestionEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: AddContentStore }>) {
    super(props);
    this.store = new SelectQuestionEditStore();
    this.setup();
  }

  setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        () => this.props.store.setValid(this.store.valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Content,
        () => this.props.store.setContents(this.store.x9Content),
        {fireImmediately: true}
      ));
  }

  render() {
    return Array.from(selectQuestionEditStoreRenderer(this.store));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
